import { useTranslation } from 'react-i18next';

const testimonials = {
  en: [
    {
      quote: 'The fluffiest donuts I’ve ever had. And that chocolate glaze? 🤤',
      name: 'Sophie R.',
      rating: 5,
    },
    {
      quote: 'Loved the pickup system. So fresh, so easy, so good.',
      name: 'Julien B.',
      rating: 4,
    },
    {
      quote: 'My kids are obsessed. Maison Beigne is a Saturday tradition now.',
      name: 'Karine M.',
      rating: 5,
    },
    {
      quote: 'Tried it once and immediately ordered a dozen more. Can’t go back.',
      name: 'Maxime T.',
      rating: 5,
    },
  ],
  fr: [
    {
      quote: 'Les beignes les plus moelleux que j’ai jamais mangés. Et ce glaçage au chocolat ? 🤤',
      name: 'Sophie R.',
      rating: 5,
    },
    {
      quote: 'Le système de commande est super simple et les beignes sont toujours frais.',
      name: 'Julien B.',
      rating: 4,
    },
    {
      quote: 'Mes enfants en raffolent. Maison Beigne fait partie de nos samedis maintenant.',
      name: 'Karine M.',
      rating: 5,
    },
    {
      quote: 'Un seul essai et j’ai tout de suite commandé une douzaine. Incroyable.',
      name: 'Maxime T.',
      rating: 5,
    },
  ],
};

export default function Testimonials() {
  const { i18n } = useTranslation();
  const lang = i18n.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <div className="max-w-4xl mx-auto my-12 px-4">
      <h2 className="text-3xl font-bold text-center text-pink-700 dark:text-pink-300 mb-6 font-sans">
        ❤️ {lang === 'fr' ? 'Ce que disent nos clients' : 'What Our Customers Say'}
      </h2>

      <div className="grid gap-6 md:grid-cols-2">
        {testimonials[lang].map(({ quote, name, rating }, idx) => (
          <div
            key={idx}
            className="relative bg-white dark:bg-gray-800 p-6 rounded-lg shadow text-left"
          >
            <p className="text-gray-700 dark:text-gray-200 italic">“{quote}”</p>
            <p className="mt-4 font-semibold text-pink-700 dark:text-pink-300">— {name}</p>

            {/* ⭐ Rating at bottom right */}
            <div className="absolute bottom-4 right-4 flex">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={`text-yellow-400 ${i < rating ? '' : 'opacity-30'}`}>
                  ★
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
